"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMenu = void 0;
exports.getMenu = function (name) {
    return name.replace("-", "_");
};
//# sourceMappingURL=get-menu.js.map